
export async function useAccordion(target: string) {
  if (document.querySelector(target)) {
    const { default: Accordion } = await import('accordion-js')
    new Accordion(target, {
      openOnInit: [],
      collapse: true,
      triggerClass: 'uno-trigger',
      panelClass: 'uno-panel',
      elementClass: 'uno-accordion',
      activeClass: 'active'
    })
  }
}